import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import { styled } from '@mui/material/styles';

export const FormContent = styled(DialogContent, {
  shouldForwardProp: prop => prop !== '$compactSpacing',
})<{ $compactSpacing?: boolean }>(({ theme, $compactSpacing }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: theme.spacing(2),
  ...($compactSpacing && {
    '&&.MuiDialogContent-root': {
      paddingBottom: theme.spacing(1),
    },
    '&& .MuiFormHelperText-root': {
      marginTop: 0,
      lineHeight: 1.25,
    },
  }),
}));

export const FormActions = styled(DialogActions)(({ theme }) => ({
  gap: theme.spacing(1),
  flexWrap: 'wrap',
}));
